import { useMemo } from 'react';
import type { InfiniteData } from '@tanstack/react-query';

import type { VehicleListItem } from 'Types/vehicle';

import type { VehicleListFetcher } from '../useFetchVehicleList/useFetchVehicleList.types';

import { formatVehicleListData } from './useFormatVehicleListData.helpers';

interface UseFormatVehicleListDataParams {
	selectedVehicle?: VehicleListItem;
	vehicles?: InfiniteData<VehicleListFetcher>;
}

const useFormatVehicleListData = ({ selectedVehicle, vehicles }: UseFormatVehicleListDataParams): VehicleListItem[] =>
	useMemo(() => formatVehicleListData({ selectedVehicle, vehicles }), [vehicles, selectedVehicle]);

export default useFormatVehicleListData;
